import { Box, Container } from "@mui/material";
import React from "react";
import Rocket from "../assets/logo/rocket.svg";

export default function AppScreenLoader() {
    return (
        <Container sx={{ height: '100%', position: 'fixed', display: 'flex', justifyContent: 'center', alignItems: 'center', left: 0, right: 0, top: 0 }} disableGutters maxWidth="lg">
            <Box marginLeft={-10} marginTop={-10}>
                <Box className="spin" position={"absolute"}></Box>
                <Rocket style={{ width: 84, position: "absolute" }} />
            </Box>
        </Container>
    )
}

AppScreenLoader.propTypes = {};
